import React from 'react';
import { Outlet, Link, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { logout } from '../store/authSlice';

const Layout = (): JSX.Element => {
  return (
    <div className="min-h-screen bg-army-950">
      <header className="bg-navy-900 border-b border-navy-800 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-8">
          <Link to="/" className="text-neon font-bold text-xl tracking-tight">
            🍽 supper
          </Link>
          <Nav />
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  )
}

const Nav = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((s) => s.auth.user);
  return (
    <nav className="flex items-center justify-between flex-1">
      <ul className="flex gap-6">
        <NavLink name="Home" path="/" />
        <NavLink name="Search" path="/search" />
        <NavLink name="Recipes" path="/recipes" />
        <NavLink name="Food" path="/foods" />
        <NavLink name="Shopping List" path="/shopping-list" />
        {user?.is_admin && <NavLink name="Admin" path="/admin" />}
      </ul>
      {user ? (
        <div className="flex items-center gap-4 ml-6">
          <Link to="/account" className="text-xs text-gray-500 hover:text-white transition-colors">
            {user.email}
          </Link>
          <button
            onClick={() => dispatch(logout())}
            className="text-xs text-gray-500 hover:text-white transition-colors"
          >
            Sign out
          </button>
        </div>
      ) : (
        <Link to="/login" className="text-xs text-gray-500 hover:text-white transition-colors ml-6">
          Sign in
        </Link>
      )}
    </nav>
  )
}

const NavLink = ({ name, path }: { name: string; path: string }): JSX.Element => {
  const location = useLocation();
  const isActive = path === '/'
    ? location.pathname === '/'
    : location.pathname.startsWith(path);

  return (
    <li>
      <Link
        to={path}
        className={`text-sm font-medium transition-colors ${
          isActive ? 'text-neon' : 'text-gray-500 hover:text-white'
        }`}
      >
        {name}
      </Link>
    </li>
  )
}

export default Layout;
